<template>
  <BreadCrumb PageTitle="Deploy" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <DeployContent />
    </div>
  </div>
</template>

<script setup>
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import DeployContent from "../../components/Admin/Deploy/DeployContent.vue";

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>
